<script>
// 新建服务商
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar";
import {useVuelidate} from "@vuelidate/core";
import {required, email} from "@vuelidate/validators";
import {alertError, successMsg} from "@/helpers/swal";
import {createServiceCompany} from "@/service";
import { INDUSTRY, COMPANY_SIZE } from "@/config/common";
import datePickr from "@/views/widgets/date-pickr";
import LocationSelect from "@/views/widgets/location-select";
import i18n from "@/i18n";

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.create')
    }
  },
  data () {
    return {
      showModal: false,
      logo: 0,
      form: {
      },
      INDUSTRY,
      COMPANY_SIZE,
    }
  },
  validations: {
    form: {
      name: { required },
      email: { email },
    }
  },
  methods: {
    open() {
      this.formInit()
      this.showModal = true
    },
    formInit() {
      this.form = {
        logo: null,
        name: null,
        tel: null,
        email: null,
        industry: null,
        web: null,
        build_at: null,
        size: null,
        province: null,
        city: null,
        country: null,
        address: null,
        introduce: null,
      }
    },
    async save() {
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      // if (!this.form.logo) {
      //   alertError('提示', '请上传logo！')
      //   return
      // }
      for (let i = 0; i < this.v$.form.email.$errors.length; i++) {
        if (this.v$.form.email.$errors[i].$message == 'Value is not a valid email address') {
          alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
          return
        }
      }

      if (!result) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      createServiceCompany(this.form).then(res => {
        if (![200, 201].includes(res.meta.code)) {
          alertError(this.$t('base.prompt'), res.meta.message)
          return
        }
        successMsg( this.$t('page.service-company') + this.$t('serviceCompany.create_success'))
        this.showModal = false
        this.$emit('refresh')
      }).catch(err => {
        alertError(this.$t('base.prompt'), this.$t('page.errorOccurred'))
        console.log(err)
      })
    },
    locationSelected(selected) {
      if (selected) {
        this.form.country = selected[0]
        this.form.province = selected[1]
        this.form.city = selected[2]
      } else {
        this.form.country = null
        this.form.province = null
        this.form.city = null
      }
    }
  },
  components: {
    uploadAvatar,
    datePickr,
    LocationSelect,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
      size="lg"
  >
    <div class="modal-body border-top" style="max-height: 60vh;">
      <div class="logo-wraper d-flex justify-content-center mb-3">
        <upload-avatar v-model="form.logo" input-id="uploadLogo" filename-prefix="sc" return-type="url"></upload-avatar>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('serviceCompany.company_name')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
        <input type="text" class="form-control" :class="v$.form.name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('serviceCompany.company_name')" v-model="form.name" @blur="v$.form.name.$touch()" required/>
      </div>

      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.industry')}}</label>
        <Multiselect
            class="form-control"
            :can-clear="false"
            :can-deselect="false"
            v-model="form.industry"
            :close-on-select="true"
            :searchable="true"
            :create-option="false"
            :placeholder="this.$t('page.select-industry')"
            :options="INDUSTRY"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.contactNumber')}}</label>
        <input type="text" class="form-control" :placeholder="this.$t('page.contactNumber')" v-model="form.tel"/>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.email')}}</label>
        <input type="text" class="form-control" :class="v$.form.email.$errors.length ? 'is-invalid' : ''" :placeholder="$t('page.email')" v-model="form.email"/>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.homepage')}}</label>
        <input type="text" class="form-control" :placeholder="this.$t('page.homepage')" v-model="form.web"/>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.establishedTime')}}</label>
        <date-pickr class="w-100" v-model="form.build_at" :placeholder="this.$t('page.establishedTime')"></date-pickr>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.companySize')}}</label>
        <Multiselect
            class="form-control"
            :can-clear="false"
            :can-deselect="false"
            v-model="form.size"
            :close-on-select="true"
            :searchable="true"
            :create-option="false"
            :placeholder="this.$t('page.companySize')"
            :options="COMPANY_SIZE"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.company_address')}}</label>
        <div class="w-100">
          <location-select @selected="locationSelected"></location-select>
          <input type="text" class="form-control mb-3" :placeholder="this.$t('page.detailedAddress')" v-model="form.address"/>
        </div>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.companyIntroduction')}}</label>
        <b-form-textarea class="form-control" rows="5" max-rows="8" :placeholder="this.$t('page.companyIntroduction')" v-model="form.introduce"></b-form-textarea>
      </div>
    </div>

    <div class="modal-footer v-modal-footer" style="padding-right: 20px;padding-bottom: 20px;">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="save">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>
<style scoped>
.field-title {
  width: 300px;
}
</style>
